// Wait for the DOM to be fully loaded
  document.addEventListener("DOMContentLoaded", function() {
    // Select all elements with the class 'productitem--action-trigger'
    var triggerButtons = document.querySelectorAll('.productitem--action-trigger');
    
    // Attach a click event listener to each button
    triggerButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default link/button behavior
        
        // Check if the function is available, then call it to open the cart
        if (typeof window.upcartOpenCart === 'function') {
          window.upcartOpenCart();
        } else {
          console.error("UpCart open cart function is not available.");
        }
      });
    });
  });